import React from 'react';
import { Link } from 'react-router-dom';

export default function NavMain() {
  const currentUrl = window.location.pathname;
  const active = (path) => (currentUrl === path ? 'text-primary' : 'text-muted');

  return (
    <div className="d-flex justify-content-around w-100 py-2">
      <Link to="/home" className={`d-flex flex-column align-items-center ${active('/home')}`}>
        <i className="fas fa-home" style={{ fontSize: 20, color : '#ffbc02' }}></i>
        <small>Home</small>
      </Link>

      <Link to="/dashboard" className={`d-flex flex-column align-items-center ${active('/dashboard')}`}>
        <i className="fas fa-chart-line" style={{ fontSize: 20, color : '#ffbc02' }}></i>
        <small>Dashboard</small>
      </Link>

      <Link to="/notice" className={`d-flex flex-column align-items-center ${active('/notice')}`}>
        <i className="fas fa-bell" style={{ fontSize: 20, color : '#ffbc02' }}></i>
        <small>Notice</small>
      </Link>
    </div>
  );
}
